import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { MAT_LEGACY_SELECT_CONFIG, MatLegacySelect, MatLegacySelectChange } from "@angular/material/legacy-select";
import { MANUAL_PROCESS_OPTIONS } from "@shared/constants/payment-status-options";
import { ManualProcessDialogRefData } from "@shared/models/payouts.types";
import { PayoutsService } from "@shared/services/payouts/payouts.service";
import { ToastService } from "@shared/services/toast/toast.service";
import { Subject } from "rxjs";

@Component({
	selector: "app-manual-payout-process-dialog",
	templateUrl: "./manual-payout-process-dialog.component.html",
	styleUrl: "./manual-payout-process-dialog.component.scss",
	providers: [
		{
			provide: MAT_LEGACY_SELECT_CONFIG,
			useValue: { overlayPanelClass: "manual-process-option-panel-container" }
		}
	]
})
export class ManualPayoutProcessDialogComponent implements OnInit {
	optionSelectionsForm!: FormGroup;
	manualProcessOption = MANUAL_PROCESS_OPTIONS;
	headerTitle = "";
	manualProcess = "";
	selectedOption = "";
	optionOpen = false;
	showTextInput = false;
	enableContinue = false;
	messageValue = "";

	destroy$: Subject<void> = new Subject();

	@ViewChild("matSelectOption") matSelectOption!: MatLegacySelect;

	/** IMPORT DECLARATION */
	private payoutService = inject(PayoutsService);
	private toastService = inject(ToastService);
	public dialogRef = inject(MatDialogRef<ManualPayoutProcessDialogComponent>);
	public data = inject<ManualProcessDialogRefData>(MAT_DIALOG_DATA);

	ngOnInit(): void {
		this.initializeDialogText(this.data.headerTitle);
	}

	initializeDialogText(bulkSelected: string): void {
		this.headerTitle = bulkSelected!;
		this.manualProcess = this.data.headerTitle === "MARK AS BOOKED" ? "Booked" : "Processed";
	}

	optionSelectionChange(selected: MatLegacySelectChange): void {
		if (selected.value?.value !== "others") {
			this.enableContinue = true;
			this.showTextInput = false;
			this.messageValue = selected.value?.text;
		} else {
			this.enableContinue = false;
			this.showTextInput = selected.value?.value === "others";
		}
	}

	toggleOptionPanel(event: MouseEvent, select: MatLegacySelect): void {
		if (select.panelOpen) {
			select.close();
			event.preventDefault();
			event.stopPropagation();
		}

		select.open();
	}

	confirm(): void {
		const status = this.data.status;
		const transactionIds = this.data.selectedTransactions;
		this.payoutService.markAsBookedOrProcessed(status, transactionIds, this.messageValue).subscribe({
			next: _ => {
				this.toastService.showSuccess("Data has been submitted successfully");
				this.dialogRef.close(true);
			},
			error: err => console.log("We have a problem.", err)
		});
	}

	cancel(): void {
		this.dialogRef.close(false);
	}

	noClick(): void {
		this.dialogRef.close();
	}

	isOptionOpen(isOpen: boolean): void {
		this.optionOpen = isOpen;
	}

	textInput(event: any): void {
		this.enableContinue = event.target.value.length > 0;
		this.messageValue = event.target.value;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
